



















import { Component, Prop, Provide, Vue, Watch } from 'vue-property-decorator'
import { getFilteredMenuData, getMatchPath, getOpenKeys } from '../service/common'
import { USER_GROUPS } from '../service/constant'

@Component
export default class LeftMenu extends Vue {
  private openKeys: string[] = []
  private selectedKeys: string[] = []
  private isClick = false

  public get menus() {
    return getFilteredMenuData(this.groups)
  }

  private get groups() {
    return this.$store.state[USER_GROUPS]
  }

  public handleClick(e) {
    this.isClick = true
    this.$router.push({ path: e.key }).catch((err) => {}) // 跳转
  }

  @Watch('$route.path')
  private onPathChange() {
    setTimeout(() => {
      this.update()
    })
  }

  @Watch('openKeys')
  private onOpenKeysChange(val) {}

  private created() {
    this.update()
  }

  private update() {
    if (!this.isClick) {
      this.openKeys = getOpenKeys(this.$route.path, this.groups)
      this.selectedKeys = [getMatchPath(this.$route.path, this.groups)]
    }
    this.isClick = false
  }
}
